import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import DialogContent from '@material-ui/core/DialogContent';

import Modal from '../../../_ui/Modal/Modal';
import {
  StyledModalContainer,
  TableWrapper,
  TreeSelectWrapper
} from './ServiceProvidersModalStyles';
import ServiceProvidersTable from './ServiceProvidersTable';
import useColumnFilter from '../../../components/TableFilter/useColumnFilter';
import { changeFormValue } from '../../../passport/Passport';
import TreeSelect from '../../../modules/TreeSelect/TreeSelect';
import useTree from '../../../components/TableFilter/ColumnsFilters/FilterTreeSelect/useTree';
import './ServiceProvidersTranslate';
import ClearIcon from '@material-ui/icons/Clear';
import Button from '@material-ui/core/Button';

const lookupId = 60;
const FILTER_CODE = '190000000';
const DEFAULT_LOCATION = '191010000';


function ServiceProvidersModal({ modal, setFormData, currentValueRegionField, currentValueCorrectionTypeField,currentValueRehabTypeField }) {
  const { data, close } = modal;
  const { t, i18n } = useTranslation();
  const { value, setFilter } = useColumnFilter('extraFilters', 1);
  const parsedValue = JSON.parse(value) || {};
  const initialLocation =
    currentValueRegionField || DEFAULT_LOCATION;
  const disabledLocationChange = true;    // в рамках задачи 1153 блокирую перевыбор локации

  const [selectedLocation, setSelectedLocation] = React.useState(initialLocation);
  const { tree, onExpand, loadingArr } = useTree({
    lookupId,
    filterCode: FILTER_CODE,
    value: selectedLocation
  });
  const onLocationChange = (v) => {
    setSelectedLocation(v);
    setFilter(JSON.stringify({
      ...parsedValue,
      locationCode: v
    }));
  };

  const onClickRow = ({ original }) => {
    if (
      data.code === 'request_form_accept_doc_edu_short.School_Name_applic' ||
      data.code === 'request_form_accept_school_short.School_Name_applic' ||
      data.code === 'request_form_school_transfer_short.School_Name_applic' ||
      data.code === 'request_form_voucher_queue_short.choice_ddo'
    ) {
      setFormData({ ...original });
    }
    if (data.code) {
      changeFormValue(data.code, original[`${i18n.language}_name`]);
    } else {
      setFormData({ ...original });
    }
    modal.close();
  };

  const clearExtraFilters = () => {
    const parsed = JSON.parse(value) || {};
    delete parsed.correctionType;
    delete parsed.rehabType;
    setFilter(JSON.stringify(parsed));
  };

  useEffect(() => {
    setFilter(JSON.stringify({
      ...parsedValue,
      locationCode: currentValueRegionField,
      correctionType: currentValueCorrectionTypeField || parsedValue.correctionType,
      rehabType: currentValueRehabTypeField || parsedValue.rehabType
    }));

    if (data.code) {
      if (['request_form_accept_doc_edu_short.School_Name_applic',
        'request_form_accept_school_short.School_Name_applic',
        'request_form_school_transfer_short.School_Name_applic'].includes(data.code)) {
        let typeApplic = null;
        let areaCode = null;
        if (data.code === 'request_form_accept_school_short.School_Name_applic') {
          typeApplic = window.PassportForm.values['request_form_accept_school_short.Type_applic'];
          areaCode = window.PassportForm.values['request_form_accept_school_short.AreaCode_applic'];
        } else if (data.code === 'request_form_school_transfer_short.School_Name_applic') {
          typeApplic = window.PassportForm.values['request_form_school_transfer_short.Type_applic'];
          areaCode = window.PassportForm.values['request_form_school_transfer_short.AreaCode_applic'];
        } else {
          typeApplic =
            window.PassportForm.values['request_form_accept_doc_edu_short.Type_applic'];
          areaCode =
            window.PassportForm.values[
              'request_form_accept_doc_edu_short.AreaCode_applic'
            ];
        }
        if (['2', '3', '4'].includes(typeApplic)) {
          areaCode =
            window.PassportForm.values[
              'request_form_accept_doc_edu_short.AreaCode_applic_short'
            ];
        }
        let typeCode, subTypeCode;
        switch (typeApplic) {
          case '0':
          case '1':
            typeCode = '02,07';
            break;
          case '2':
          case '3':
            typeCode = '13';
            break;
          case '4':
            typeCode = '12';
            break;
          case '5':
            typeCode = '08';
            subTypeCode = '08.3,08.4,08.5,08.6';
            break;
          case '6':
            typeCode = '02';
            break;
          default:
            break;
        }
        setFilter(
          JSON.stringify({
            ...parsedValue,
            locationCode: areaCode,
            serviceProviderType: typeCode,
            serviceProviderSubType: subTypeCode
          })
        );
      } else if (data.code === 'request_form_voucher_queue_short.choice_ddo') {
        setFilter(JSON.stringify({
          ...parsedValue,
          locationCode:currentValueRegionField ,
          correctionType: currentValueCorrectionTypeField || parsedValue.correctionType,
          rehabType: currentValueRehabTypeField || parsedValue.rehabType,
          serviceType: 'voucher_queue'
        }));
      } else {
        setFilter(
          JSON.stringify({
            ...parsedValue,
            serviceProviderType: '03'
          })
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      open
      maxWidth="lg"
      title={t('serviceProviders_title')}
      onClose={close}
      scroll="paper"
    >
      <DialogContent dividers>
        <div className="overflow-auto">
          <StyledModalContainer>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <TreeSelectWrapper>
                <span>{t('serviceProviders_columnLocation')}</span>
                <TreeSelect
                  lookupId={lookupId}
                  loadingArr={loadingArr}
                  onExpand={disabledLocationChange ? () => {} : onExpand}
                  data={tree}
                  withoutForm
                  fullWidth
                  onChange={disabledLocationChange ? () => {} : onLocationChange}
                  value={selectedLocation}
                  disabled={disabledLocationChange}
                  clearable={false}
                  style={disabledLocationChange ? { pointerEvents: 'none' } : {}}
                />
              </TreeSelectWrapper>
              <div>
                <Button
                  variant="contained"
                  startIcon={<ClearIcon />}
                  onClick={clearExtraFilters}
                >
                  {t('serviceProviders_clearFilter')}
                </Button>
              </div>
            </div>
            <TableWrapper>
              <ServiceProvidersTable index={1} onClickRow={onClickRow} />
            </TableWrapper>
          </StyledModalContainer>
        </div>
      </DialogContent>
    </Modal>
  );
}

export default ServiceProvidersModal;
